import OneCalculatedBox from "./OneCalculatedBox";

const CalculatedBoxes = ({ calculatedData, userData }) => {
  return (
    <div className="calculatedBoxes">
      <div className="calculatedBoxesRow">
        <OneCalculatedBox
          type="link"
          content="About Your Business"
          percent={calculatedData?.business}
          link="/walkthrough/about-you"
        />
        <OneCalculatedBox
          type="link"
          content="Online Presence"
          percent={calculatedData?.online}
          link="/walkthrough/online-presence"
        />
      </div>
      <div className="calculatedBoxesRow">
        <OneCalculatedBox
          type="link"
          content="Product Categories"
          percent={calculatedData?.categories}
          link="/walkthrough/shop-categories"
        />
        <OneCalculatedBox
          type="function"
          content="Payment"
          percent={calculatedData?.payment}
          userData={userData}
        />
      </div>
    </div>
  );
};

export default CalculatedBoxes;
